/*!
 * © 2026 Soulcute / Tailoring Consult — Todos los derechos reservados.
 * Código propietario. Prohibida su reproducción o redistribución sin autorización expresa.
 * Contacto: administracion@tailoringconsult.com
 */
(function(){
function init(){
  var el=document.getElementById('scp');
  if(!el)return;
  var dataEl=document.getElementById('scp-data');
  if(!dataEl)return;
  var P;
  try{P=JSON.parse(dataEl.textContent)}catch(e){return}

  var optsContainer=document.getElementById('scp-opts');
  var overlay=document.getElementById('scp-ov');
  var mlist=document.getElementById('scp-mlist');
  var mtitle=document.getElementById('scp-mtitle');
  var mcart=document.getElementById('scp-mcart');
  var mcount=document.getElementById('scp-mcount');
  var closeBtn=document.getElementById('scp-close');
  var radios=el.querySelectorAll('input[name="scp-q"]');
  var opts=el.querySelectorAll('.scp__opt');
  var curQty=0;
  var selected=[];
  var price=Math.round(P.priceCents/100);

  function fmt(n){return '$'+Math.round(n).toLocaleString('es-CL')}

  radios.forEach(function(r){
    var qty=parseInt(r.value);
    var disc=parseInt(r.dataset.disc);
    var total=price*qty;
    var saved=Math.round(total*disc/100/10)*10;
    var final_=Math.round((total-saved)/10)*10;
    var card=r.closest('.scp__opt').querySelector('.scp__card');
    var svEl=card.querySelector('[data-role="save"]');
    var prEl=card.querySelector('[data-role="price"]');
    var origEl=card.querySelector('[data-role="orig"]');
    if(svEl)svEl.textContent='Ahorra '+fmt(saved);
    if(prEl)prEl.textContent=fmt(final_);
    if(origEl)origEl.textContent=fmt(total);
  });

  function getGroups(){
    var groups=[];var seen={};
    P.variants.forEach(function(v){
      var color=v.options[0]||v.title;
      if(!seen[color]){
        seen[color]=true;
        var sizes=[];
        P.variants.forEach(function(v2){
          if(v2.options[0]===color){
            sizes.push({id:v2.id,label:v2.options[1]||v2.title,options:v2.options,available:v2.available!==false});
          }
        });
        var anyAvail=sizes.some(function(s){return s.available});
        groups.push({color:color,image:v.image||P.image,price:Math.round(v.priceCents/100),sizes:sizes,available:anyAvail});
      }
    });
    return groups;
  }

  function applyLayout(){
    /* NO-OP — posiciones FIJAS desde el Liquid: Pack 3 en centro (favorito), Pack 2 lateral top, Pack 4 lateral bot.
       La selección de radio cambia solo el dot ●; las cards no se reordenan. */
  }

  function updateCards(){
    /* Limpiar todos los expand y reset display (revierte el inline style del último activo) */
    el.querySelectorAll('.scp__expand').forEach(function(e){e.innerHTML='';e.style.display=''});
    if(curQty<=0)return;

    /* Aplicar swap dinámico de grid positions (no-op actual) */
    applyLayout();

    /* El expand va dentro del card del radio CHECKED — sea center o lateral.
       Si por algún motivo no hay checked, cae al center. */
    var checked=el.querySelector('input[name="scp-q"]:checked');
    var activeOpt=checked?checked.closest('.scp__opt'):el.querySelector('.scp__opt--center');
    if(!activeOpt)return;
    var expand=activeOpt.querySelector('.scp__expand');
    if(!expand)return;
    /* Forzar visibilidad por si la card es lateral (CSS la oculta por default) */
    expand.style.display='flex';

    if(curQty===1){
      /* 1 unidad: agrega variante actual directo (sin modal) */
      expand.innerHTML='<div class="scp__exp-info"><img src="'+P.image+'" class="scp__exp-img"><span class="scp__exp-txt">1x '+P.title+'</span></div><button type="button" class="scp__exp-btn" data-action="add-single">Agregar 1 unidad</button>';
      expand.querySelector('.scp__exp-btn').addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();addSingleVariant();
      });
    }else{
      expand.innerHTML='<div class="scp__exp-info"><img src="'+P.image+'" class="scp__exp-img"><span class="scp__exp-txt">'+curQty+'x '+P.title+'</span></div><button type="button" class="scp__exp-btn">Elige</button>';
      expand.querySelector('.scp__exp-btn').addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();openModal();
      });
    }
  }

  function addSingleVariant(){
    /* Toma el variant_id de la URL o el primero disponible */
    var urlP=new URLSearchParams(window.location.search);
    var vid=parseInt(urlP.get('variant'))||0;
    if(!vid){
      var firstAvail=P.variants.find(function(v){return v.available!==false});
      if(firstAvail)vid=firstAvail.id;
    }
    if(!vid)return;
    var btn=el.querySelector('.scp__exp-btn[data-action="add-single"]');
    if(btn){btn.textContent='Agregando...';btn.disabled=true}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
      .then(function(r){return r.json()}).then(function(){
        if(btn)btn.textContent='Agregado!';
        setTimeout(function(){if(window.scOpenCartDrawer){scOpenCartDrawer()}else{window.location.href='/cart'}},700);
      }).catch(function(){
        if(btn){btn.textContent='Agregar';btn.disabled=false}
      });
  }

  function openModal(){
    selected=[];
    mtitle.textContent='Elige tus '+curQty+' productos';
    var groups=getGroups();
    var html='';
    groups.forEach(function(g,gi){
      html+='<div class="scp__mi" data-gi="'+gi+'" id="scp-mi-'+gi+'">';
      html+='<img src="'+(g.image||P.image)+'" class="scp__mi-img">';
      html+='<div class="scp__mi-info">';
      html+='<div class="scp__mi-name">'+P.title+' '+g.color+'</div>';
      html+='<div class="scp__mi-price">'+fmt(g.price)+'</div>';
      html+='<div class="scp__mi-row">';
      html+='<div class="scp__mi-field"><label>Talla</label><div class="scp__mi-sizes" data-gi="'+gi+'">';
      var firstAvailIdx=-1;for(var fi=0;fi<g.sizes.length;fi++){if(g.sizes[fi].available){firstAvailIdx=fi;break}}
      g.sizes.forEach(function(s,si){
        var cls='scp__mi-size'+(si===firstAvailIdx?' scp__mi-size--active':'')+(s.available?'':' scp__mi-size--out');
        var ttl=s.available?s.label:s.label+' - Sin stock';
        html+='<button type="button" class="'+cls+'" data-vid="'+s.id+'" data-gi="'+gi+'" title="'+ttl+'"'+(s.available?'':' disabled')+'>'+s.label+'</button>';
      });
      html+='</div></div>';
      html+='</div></div>';
      html+='<div class="scp__mi-actions">';
      html+='<div class="scp__mi-qty-wrap" data-gi="'+gi+'" style="display:flex;align-items:center;gap:6px;">';
      html+='<button type="button" class="scp__mi-minus" data-gi="'+gi+'" style="width:32px;height:32px;border:1.5px solid #ddd;border-radius:6px;background:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#333;">-</button>';
      html+='<span class="scp__mi-qty-num" data-gi="'+gi+'" style="font-size:14px;font-weight:700;min-width:20px;text-align:center;">0</span>';
      html+='<button type="button" class="scp__mi-plus" data-gi="'+gi+'" style="width:32px;height:32px;border:none;border-radius:6px;background:#000;color:#fff;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;">+</button>';
      html+='</div>';
      html+='</div>';
      html+='</div>';
    });
    mlist.innerHTML=html;

    // Size button clicks — solo marca activa (NO auto-add)
    mlist.querySelectorAll('.scp__mi-size').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(btn.classList.contains('scp__mi-size--out'))return;
        var container=btn.closest('.scp__mi-sizes');
        container.querySelectorAll('.scp__mi-size').forEach(function(b){b.classList.remove('scp__mi-size--active')});
        btn.classList.add('scp__mi-size--active');
      });
    });

    // Plus button clicks
    mlist.querySelectorAll('.scp__mi-plus').forEach(function(btn){
      btn.addEventListener('click',function(){
        var gi=parseInt(btn.dataset.gi);
        var totalSelected=selected.length;
        if(totalSelected>=curQty){return}
        var item=mlist.querySelector('#scp-mi-'+gi);
        var activeSize=item.querySelector('.scp__mi-size--active');
        var varId=activeSize?parseInt(activeSize.dataset.vid):0;
        selected.push({gi:gi,variantId:varId});
        item.classList.add('scp__mi--sel');
        updateQtyDisplay(gi);
        updateCount();
      });
    });

    // Minus button clicks — quita el último de la talla activa, si no hay quita el último cualquiera
    mlist.querySelectorAll('.scp__mi-minus').forEach(function(btn){
      btn.addEventListener('click',function(){
        var gi=parseInt(btn.dataset.gi);
        var item=mlist.querySelector('#scp-mi-'+gi);
        var activeSize=item.querySelector('.scp__mi-size--active');
        var activeVid=activeSize?parseInt(activeSize.dataset.vid):0;
        var idx=-1;
        // Primero buscar uno con variantId de la talla activa
        for(var i=selected.length-1;i>=0;i--){
          if(selected[i].gi===gi && selected[i].variantId===activeVid){idx=i;break}
        }
        // Si no encontró, quita cualquiera del grupo
        if(idx===-1){
          for(var j=selected.length-1;j>=0;j--){
            if(selected[j].gi===gi){idx=j;break}
          }
        }
        if(idx===-1)return;
        selected.splice(idx,1);
        var count=selected.filter(function(s){return s.gi===gi}).length;
        if(count===0) item.classList.remove('scp__mi--sel');
        updateQtyDisplay(gi);
        updateCount();
      });
    });

    updateCount();
    overlay.style.display='flex';document.body.style.overflow='hidden';
  }

  function updateQtyDisplay(gi){
    var count=selected.filter(function(s){return s.gi===gi}).length;
    var numEl=mlist.querySelector('.scp__mi-qty-num[data-gi="'+gi+'"]');
    if(numEl) numEl.textContent=count;
    // Actualizar badges por talla
    updateSizeBadges(gi);
  }

  function updateSizeBadges(gi){
    var item=mlist.querySelector('#scp-mi-'+gi);
    if(!item) return;
    // Contar por variantId
    var countByVid={};
    selected.filter(function(s){return s.gi===gi}).forEach(function(s){
      countByVid[s.variantId]=(countByVid[s.variantId]||0)+1;
    });
    // Update badge en cada size button
    item.querySelectorAll('.scp__mi-size').forEach(function(btn){
      var vid=parseInt(btn.dataset.vid);
      var n=countByVid[vid]||0;
      var existing=btn.querySelector('.scp__mi-size-badge');
      if(existing) existing.remove();
      if(n>0){
        var badge=document.createElement('span');
        badge.className='scp__mi-size-badge';
        badge.textContent=n;
        btn.appendChild(badge);
        btn.classList.add('scp__mi-size--has');
      } else {
        btn.classList.remove('scp__mi-size--has');
      }
    });
  }

  function updateCount(){
    var total=selected.length;
    mcount.innerHTML='Seleccionados: <strong>'+total+' de '+curQty+'</strong>';
    if(total>=curQty){
      mcart.disabled=false;mcart.textContent='AGREGAR PACK AL CARRITO';mcart.classList.add('scp__mcart--ready');
    } else {
      mcart.disabled=true;var f=curQty-total;
      mcart.textContent='Falta elegir '+f+' producto'+(f>1?'s':'');mcart.classList.remove('scp__mcart--ready');
    }
  }

  function closeModal(){overlay.style.display='none';document.body.style.overflow=''}

  function addToCart(){
    if(selected.length<curQty)return;
    var items=selected.map(function(s){return{id:s.variantId,quantity:1}});
    mcart.textContent='Agregando...';mcart.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json()}).then(function(){
      mcart.textContent='Pack agregado!';
      setTimeout(function(){closeModal();if(window.scOpenCartDrawer){scOpenCartDrawer()}else{window.location.href='/cart'}},800);
    }).catch(function(){mcart.textContent='AGREGAR PACK AL CARRITO';mcart.disabled=false});
  }

  radios.forEach(function(r){r.addEventListener('change',function(){curQty=parseInt(r.value);updateCards()})});

  /* Init: si hay radio checked por defecto (Pack 3), inicializar curQty + render */
  var defaultChecked=el.querySelector('input[name="scp-q"]:checked');
  if(defaultChecked){
    curQty=parseInt(defaultChecked.value);
    updateCards();
  }
  closeBtn.addEventListener('click',closeModal);
  overlay.addEventListener('click',function(e){if(e.target===overlay)closeModal()});
  mcart.addEventListener('click',addToCart);

  // Toggle pack/notification based on variant stock
  var bisEl=document.getElementById('sc-bis');
  function toggleStock(){
    var urlP=new URLSearchParams(window.location.search);
    var vid=urlP.get('variant');
    if(vid && P.variants && bisEl){
      var found=P.variants.find(function(v){return v.id==parseInt(vid)});
      if(found && found.available===false){
        el.style.display='none';
        bisEl.style.display='block';
        var titleEl=document.getElementById('sc-bis-title');
        if(titleEl) titleEl.textContent='Talla agotada';
      } else {
        el.style.display='';
        bisEl.style.display='none';
        // Reset form
        var f=document.getElementById('sc-bis-form');
        if(f) f.style.display='flex';
        var m=document.getElementById('sc-bis-msg');
        if(m) m.style.display='none';
      }
    }
  }
  toggleStock();
  var origPush=history.pushState;
  history.pushState=function(){origPush.apply(history,arguments);setTimeout(toggleStock,100)};
  var origReplace=history.replaceState;
  history.replaceState=function(){origReplace.apply(history,arguments);setTimeout(toggleStock,100)};
  window.addEventListener('popstate',function(){setTimeout(toggleStock,100)});

  var te=document.getElementById('scp-timer');
  if(te){var m=14,s=59;setInterval(function(){s--;if(s<0){s=59;m--}if(m<0){m=14;s=59}te.textContent=(m<10?'0':'')+m+':'+(s<10?'0':'')+s},1000)}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){setTimeout(init,500)})}
else{setTimeout(init,500)}
})();